import React from "react";
// import { Link } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";

import CompanyLinksBox from "../components/companyLinksBox";

const AboutPage = () => (
  <Layout>
    <SEO title="About" />
    <div className="container">
      <div
        className="container-fluid p-2 pt-3 mb-3"
        style={{ backgroundColor: "#E9ECEF" }}
      >
        <div className="d-block text-center px-5 pb-4">
          <h1>Company Information</h1>

          <p>
            Sturminster UK is a family run business providing a range of
            construction services to commercial clients.
            <br /> From design to completion we provide a complete service
            covering all of your fit out and refurbishment needs.
          </p>
          <p>
            Our first priority is to ensure complete customer satisfaction. We
            do this by keeping things simple, providing a high quality finishes
            and keeping our costs and overheads lean. Our clients have always
            returned to us for further projects after using us once.
          </p>
          <p>
            Our range of services cater for large retailers, leisure groups,
            commercial property owners, developers, franchisees and local
            authorities. <br />
            All types of commercial fit out work can be catered for.
          </p>
        </div>
      </div>
      <CompanyLinksBox />
    </div>
  </Layout>
);

export default AboutPage;
